import { mapDataToUi } from "hooks/mapDataToOptions";
import axios from "lib/api";
import Api from "lib/api";
import { setMessage } from "modules/shared/notification/slice";

export const fetchOrganizations = async (filterValue) => {
    try {
        const response = await Api.get(`organizations`, {
            params: {
                ...(filterValue && { "filter[q]": filterValue }),
            },
        });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get Organizations`,
            isError: true,
        });
    }
};

export const fetchCategories = async (filterValue) => {
    try {
        const response = await Api.get(`location-categories`, {
            params: {
                ...(filterValue && { "filter[q]": filterValue }),
            },
        });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get Location categories`,
            isError: true,
        });
    }
};

export const addNewLocation = async (data) => {
    try {
        const response = await Api.post(`locations`, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const editLocation = async (data) => {
    try {
        const response = await Api.put(`locations/${data.data.id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const checkLocationMatches = async (data) => {
    const { lat, lang, name, clientId, matcher } = data;
    try {
        const response = await Api.get(`locations/similarities`, {
            params: {
                latitude: lat,
                longitude: lang,
                q: name,
                matcherAttribute: matcher,
                organizationId: clientId,
            },
        });
        return response;
    } catch (error) {
        return error;
    }
};

export const getFilteredOrginzation = async (filter) => {
    const response = await axios.get("/organizations", {
        params: {
            ...(filter && { "filter[q]": filter }),
        },
    });
    return mapDataToUi(response.entities.organizations);
};
export const getFilteredCities = async (filter) => {
    const response = await axios.get("/cities", {
        params: {
            ...(filter && { "filter[q]": filter }),
        },
    });
    return mapDataToUi(response.entities.cities);
};
export const getFilteredCategories = async (filter) => {
    const response = await axios.get("/location-categories", {
        params: {
            ...(filter && { "filter[q]": filter }),
        },
    });
    return mapDataToUi(response.entities.locationCategories);
};
export const getFilteredAreas = async (filter) => {
    const response = await axios.get("/areas", {
        params: {
            ...(filter && { "filter[q]": filter }),
        },
    });
    return mapDataToUi(response.entities.areas);
};
